import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { InputGroup, Form, Button } from 'react-bootstrap'
import { Table, Tooltip, message } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUnlink } from '@fortawesome/free-solid-svg-icons'

import { detachOrderDetailFromAppointment, attachOrderDetailToAppointment } from '../services'
import { getOrders } from '../../Orders/services'
import { handleError } from '../../../helpers'

export default function AppointmentOrderDetailsModal({ visible, onClose, reload, appointment }) {
    const user = useSelector(state => state.auth.user)
    const [selectedOrderId, setSelectedOrderId] = useState(null)
    const [selectedOrderDetailId, setSelectedOrderDetailId] = useState(null)
    const [orders, setOrders] = useState(null)
    const [selectedOrder, setSelectedOrder] = useState(null)

    useEffect(() => {
        !orders && getOrders({ 
            'filter[supplier_id]': user.id, 
            sort: '-registered_at', 
            'filter[pending_appointment]': 1,
            include: 'activeOrderDetails',
        })
            .then(res => setOrders(res.data.data))
            .catch(error => handleError(error))
    }, [orders, user])
    
	const columns = [
        {
            title: 'Articulo',
            dataIndex: 'sku',
        },
		{
			title: 'Orden de compra',
			dataIndex: 'article_name',
		},
        {
            title: 'Recepción Planeada',
            dataIndex: 'reception_planned_at',
        },
        {
            title: 'Acciones',
            dataIndex: 'id',
            render: (t, r) => {
                return (
                    <>
                        { appointment.order_detail_id !== r.id ? (
                            <>
                                {appointment.status.value === 'pending' ? (
                                    <div 
                                        className='btn btn-outline-primary mr-5' 
                                        onClick={() => handleDetachOrderDetail(t)}
                                    >
                                        Desasociar{" "}
                                        <FontAwesomeIcon icon={faUnlink} />
                                    </div>
                                ) : (
                                    <span className='text-muted small'>Edición no disponibles</span>
                                )}
                            </>
                        ) : (
                            <span className='text-muted small'>Orden principal</span>
                        )}
                    </>
                )
            }
        }
	]

    const handleAttachOrderDetail = () => {
        attachOrderDetailToAppointment(appointment.id, { order_detail_id: selectedOrderDetailId })
            .then(res => {
                message.success(res.data.message)
                reload()
                onClose()
            })
            .catch(error => handleError(error))
    }

    const handleDetachOrderDetail = orderDetailId => {
        detachOrderDetailFromAppointment(appointment.id, orderDetailId)
            .then(res => {
                message.success(res.data.message)
                reload()
                onClose()
            })
            .catch(error => handleError(error))
    }

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose} size='lg'>
				<ModalHeader toggle={onClose}>Ordenes de compra</ModalHeader>
				<ModalBody>
					<Table 
                        dataSource={appointment.order_details}
                        columns={columns} 
                        rowKey={r => r.id}
                        size="small"
                        bordered
                    />
                    { orders && (
                        <>
                            <InputGroup className='mt-5'>
                                <Form.Control
                                    as="select"
                                    disabled={!orders}
                                    value={selectedOrderId ? selectedOrderId : ''}
                                    onChange={e => {
                                        setSelectedOrderId(e.target.value)
                                        setSelectedOrder(orders?.find(order => order.id === parseInt(e.target.value)))
                                    }}
                                >
                                    <option value="">:: Seleccione una opción ::</option>
                                    { orders?.map(order => (
                                        <option key={order.id} value={order.id}>
                                            {order.sku}
                                        </option>
                                    )) }
                                </Form.Control>
                                <Form.Control
                                    as="select"
                                    disabled={!selectedOrder}
                                    value={selectedOrderDetailId ? selectedOrderDetailId : ''}
                                    onChange={e => setSelectedOrderDetailId(e.target.value)}
                                >
                                    <option value="">:: Seleccione una opción ::</option>
                                    { selectedOrder?.active_order_details?.map(orderDetail => (
                                        <option key={orderDetail.id} value={orderDetail.id}>
                                            {orderDetail.article_name} ({orderDetail.reception_planned_at})
                                        </option>
                                    )) }
                                </Form.Control>
                                <Button 
                                    color="primary" 
                                    onClick={() => handleAttachOrderDetail()}
                                    disabled={appointment.status.value !== 'pending'}
                                >
                                    Asociar Articulo Adicional
                                </Button>
                            </InputGroup>
                        </>
                    )}
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}